// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/no-misused-promises, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/prefer-promise-reject-errors */

import * as types from "./actionTypes";
import * as farmApi from "../../apis/farmApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";
import * as farmTypes from "../../apis/types/farmTypes";

/*
 *  Action Creators
 *
 */
export function getFarmsSuccess() {
	return { type: types.FARM_GET_FARMS_SUCCESS };
}

export function getFarmInfoSuccess() {
	return { type: types.FARM_GET_FARM_INFO_SUCCESS };
}

export function createFarmSuccess() {
	return { type: types.FARM_CREATE_FARM_SUCCESS };
}

export function updateFarmSuccess() {
	return { type: types.FARM_UPDATE_FARM_SUCCESS };
}

export function deleteFarmSuccess() {
	return { type: types.FARM_DELETE_FARM_SUCCESS };
}

export function updateFarmBoundsSuccess() {
	return { type: types.FARM_UPDATE_BOUNDS_SUCCESS };
}

export function createFarmParcelsSuccess() {
	return { type: types.FARM_CREATE_PARCELS_SUCCESS };
}

export function getFarmSummarySuccess() {
	return { type: types.FARM_GET_SUMMARY_SUCCESS };
}

export function getFarmParcelsSuccess() {
	return { type: types.FARM_GET_PARCELS_SUCCESS };
}

export function getFlightsForFarmSuccess() {
	return { type: types.FARM_GET_FLIGHTS_FOR_FARM_SUCCESS };
}

export function createDefaultViewerSettingForFarmSuccess() {
	return { type: types.FARM_CREATE_DEFAULT_VIEWER_SETTING_FOR_FARM_SUCCESS };
}

export function updateDefaultViewerSettingForFarmSuccess() {
	return { type: types.FARM_UPDATE_DEFAULT_VIEWER_SETTING_FOR_FARM_SUCCESS };
}

/*
 *  Thunks
 *
 */

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getFarms(accessToken, clientId) {
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	return (dispatch) => {
		return new Promise<farmTypes.FarmData[]>((resolve, reject) => {
			dispatch(beginApiCall());

			return farmApi
				.getFarms(accessToken, clientId)
				.then((res) => {
					dispatch(getFarmsSuccess());
					resolve(res);
				})
				.catch((error) => {
					dispatch(apiCallError());
					reject(error);
				});
		});
	};
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getFarmInfo(accessToken, clientId, farmId) {
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return farmApi
				.getFarmInfo(accessToken, clientId, farmId)
				.then((res) => {
					dispatch(getFarmInfoSuccess());
					resolve(res);
				})
				.catch((error) => {
					dispatch(apiCallError());
					reject(error);
				});
		});
	};
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function createFarm(accessToken, newFarm) {
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return farmApi
				.createFarm(accessToken, newFarm)
				.then((res) => {
					dispatch(createFarmSuccess());
					resolve(res);
				})
				.catch((error) => {
					dispatch(apiCallError());
					reject(error);
				});
		});
	};
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function updateFarm(accessToken, updateFarm) {
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return farmApi
				.updateFarm(accessToken, updateFarm)
				.then((res) => {
					dispatch(updateFarmSuccess());
					resolve(res);
				})
				.catch((error) => {
					dispatch(apiCallError());
					reject(error);
				});
		});
	};
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function deleteFarm(accessToken, clientId, farmId) {
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return farmApi
				.deleteFarm(accessToken, clientId, farmId)
				.then((res) => {
					dispatch(deleteFarmSuccess());
					resolve(res);
				})
				.catch((error) => {
					dispatch(apiCallError());
					reject(error);
				});
		});
	};
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function createFarmParcels(accessToken, clientId, farmId, parcels) {
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return farmApi
				.createFarmParcels(accessToken, clientId, farmId, parcels)
				.then((res) => {
					dispatch(createFarmParcelsSuccess());
					resolve(res);
				})
				.catch((error) => {
					dispatch(apiCallError());
					reject(error);
				});
		});
	};
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getFarmParcels(accessToken, clientId, farmId) {
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return farmApi
				.getFarmParcels(accessToken, clientId, farmId)
				.then((res) => {
					dispatch(getFarmParcelsSuccess());
					resolve(res);
				})
				.catch((error) => {
					dispatch(apiCallError());
					reject(error);
				});
		});
	};
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function updateFarmBounds(accessToken, clientId, farmId, LL, UL, UR, LR) {
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return farmApi
				.updateFarmBounds(accessToken, clientId, farmId, LL, UL, UR, LR)
				.then((res) => {
					dispatch(updateFarmBoundsSuccess());
					resolve(res);
				})
				.catch((error) => {
					dispatch(apiCallError());
					reject(error);
				});
		});
	};
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getFarmSummary(accessToken, clientId, farmId) {
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return farmApi
				.getFarmSummary(accessToken, clientId, farmId)
				.then((res) => {
					dispatch(getFarmSummarySuccess());
					resolve(res);
				})
				.catch((error) => {
					dispatch(apiCallError());
					reject(error);
				});
		});
	};
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getFlightsForFarm(farmId, clientId, accessToken) {
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return farmApi
				.getFlightsForFarm(farmId, clientId, accessToken)
				.then((res) => {
					dispatch(getFlightsForFarmSuccess());
					resolve(res);
				})
				.catch((error) => {
					dispatch(apiCallError());
					reject(error);
				});
		});
	};
}

export function createDefaultViewerSettingForFarm(
	defaults: farmTypes.FarmViewerDefaults,
	clientId: string,
	accessToken: string,
) {
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return farmApi
				.createDefaultViewerSettingForFarm(defaults, clientId, accessToken)
				.then((res) => {
					if (res.errors && res.errors.length > 0) {
						reject(res);
						dispatch(apiCallError());
					} else {
						dispatch(createDefaultViewerSettingForFarmSuccess());
						resolve(res);
					}
				})
				.catch((error) => {
					dispatch(apiCallError());
					reject(error);
				});
		});
	};
}

export function updateDefaultViewerSettingForFarm(
	defaults: farmTypes.FarmViewerDefaults,
	clientId: string,
	accessToken: string,
) {
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return farmApi
				.updateDefaultViewerSettingForFarm(defaults, clientId, accessToken)
				.then((res) => {
					if (res.errors && res.errors.length > 0) {
						reject(res);
						dispatch(apiCallError());
					} else {
						dispatch(updateDefaultViewerSettingForFarmSuccess());
						resolve(res);
					}
				})
				.catch((error) => {
					dispatch(apiCallError());
					reject(error);
				});
		});
	};
}
